import { enUS as enUS$1 } from '../../../../date-fns/locale/en-US.js';
import { format } from '../../../../date-fns/format.js';

/** English (United States) locale extended with DayPicker-specific translations. */
const enUS = {
    ...enUS$1,
    labels: {
        labelDayButton: (date, modifiers, options, dateLib) => {
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") {
                formatDate = dateLib.format.bind(dateLib);
            }
            else {
                formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
            }
            let label = formatDate(date, "PPPP");
            if (modifiers.today)
                label = `Today, ${label}`;
            if (modifiers.selected)
                label = `${label}, selected`;
            return label;
        },
        labelMonthDropdown: "Choose the Month",
        labelNext: "Go to the Next Month",
        labelPrevious: "Go to the Previous Month",
        labelWeekNumber: (weekNumber) => `Week ${weekNumber}`,
        labelYearDropdown: "Choose the Year",
        labelGrid: (date, options, dateLib) => {
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") {
                formatDate = dateLib.format.bind(dateLib);
            }
            else {
                formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
            }
            return formatDate(date, "LLLL yyyy");
        },
        labelGridcell: (date, modifiers, options, dateLib) => {
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") {
                formatDate = dateLib.format.bind(dateLib);
            }
            else {
                formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
            }
            let label = formatDate(date, "PPPP");
            if (modifiers?.today) {
                label = `Today, ${label}`;
            }
            return label;
        },
        labelNav: "Navigation bar",
        labelWeekNumberHeader: "Week Number",
        labelWeekday: (date, options, dateLib) => {
            let formatDate;
            if (dateLib && typeof dateLib.format === "function") {
                formatDate = dateLib.format.bind(dateLib);
            }
            else {
                formatDate = (d, pattern) => format(d, pattern, { locale: enUS$1, ...options });
            }
            return formatDate(date, "cccc");
        },
    },
};

export { enUS };
